// extracted by css-extract-rspack-plugin
export default {"isStatic":"_dcd3e763","overlay":"_75faa3bb","isUpdate":"_f269266a"};